var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.537 1.832c-.782 0-1.557.154-2.28.454l-.268.118a5.958 5.958 0 0 0-1.666 1.174L11 3.9l-.323-.323a5.96 5.96 0 0 0-8.428 8.428l8.103 8.103a.917.917 0 0 0 1.296 0l8.104-8.103a5.956 5.956 0 0 0 0-8.428 5.958 5.958 0 0 0-4.214-1.746Zm0 1.833a4.125 4.125 0 0 1 3.813 5.706l-.095.211a4.121 4.121 0 0 1-.8 1.127L11 18.164l-7.455-7.455A4.126 4.126 0 1 1 9.38 4.874l.972.972a.917.917 0 0 0 1.296 0l.972-.972a4.126 4.126 0 0 1 2.918-1.209Z"
  })));
};
export default SvgFavorite;